module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/client_7-b9c045713679ef9275816b9329a7b6cf.png";